module.exports = __webpack_public_path__ + "static/media/SaveAway401kFundChoicesStandard.d9f09e46.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Assets/SaveAway401kFundChoicesStandard.pdf
// module id = 308
// module chunks = 0